export type Offset = { right: number; bottom: number }
export type Size = { width: number; height: number }

export const EDGE_GAP = 8
export const DEFAULT_OFFSET: Offset = { right: 24, bottom: 24 }
export const PANEL_SIZE: Size = { width: 380, height: 600 }
export const LAUNCHER_SIZE: Size = { width: 160, height: 52 }
export const DRAG_THRESHOLD_PX = 5

const clamp = (value: number, max: number) => Math.max(EDGE_GAP, Math.min(max, value))

// Keeps the whole widget on screen, measured from the bottom-right corner.
export const clampOffset = (offset: Offset, size: Size, viewport: Size): Offset => ({
  right: clamp(offset.right, viewport.width - size.width - EDGE_GAP),
  bottom: clamp(offset.bottom, viewport.height - size.height - EDGE_GAP),
})

// The panel shrinks to fit a short or narrow window.
export const fitPanel = (viewport: Size): Size => ({
  width: Math.min(PANEL_SIZE.width, viewport.width - EDGE_GAP * 2),
  height: Math.min(PANEL_SIZE.height, viewport.height - EDGE_GAP * 2),
})

export const isOffset = (value: unknown): value is Offset =>
  typeof value === 'object' &&
  value !== null &&
  Number.isFinite((value as Offset).right) &&
  Number.isFinite((value as Offset).bottom)

// Matches the stylesheet's phone breakpoint, where the open panel becomes a full-screen sheet.
export const PHONE_SHEET_QUERY = '(max-width: 480px)'
